import { SavedSearchResponse } from '@doda/api-client/aspida/@types';
import { getSavedSearches } from '@doda/common/src/services/getSavedSearchesAPI';
import { NaviItem } from 'components/FollowSearchResultsNavigation/constants';
import { useEffect, useState } from 'react';

/**
 * 保存した検索条件
 * @param loginStatus ログイン状態
 * @param onClickMenuOpen アコーディオンメニュー開閉のイベント処理
 * @returns 保存した検索条件データとメニュー表示時のイベント処理
 */
export const useSavedSearchesList = (
  loginStatus: boolean,
  onClickMenuOpen: (item: NaviItem) => void
) => {
  const [savedSearchesList, setSavedSearchesList] = useState<
    SavedSearchResponse[]
  >([]);

  useEffect(() => {
    (async () => {
      try {
        if (loginStatus) {
          const res = await getSavedSearches();
          setSavedSearchesList(res);
        }
      } catch {
        window.DD_LOGS?.logger.error({
          message: `保存した検索条件取得の失敗`,
        });
      }
    })();
  }, [loginStatus]);

  const onClickSavedSearches = (item: NaviItem) => {
    if (!loginStatus) {
      setSavedSearchesList([]);
    }
    onClickMenuOpen(item);
  };

  return {
    savedSearchesList,
    onClickSavedSearches,
  };
};
